<div class="d-box mt-2 border rounded p-2" *ngIf="criterion$ | async as criterion">
  <ng-container *ngIf="decisionInputs$ | async as decisionInputs">
    <ng-container *ngIf="!decisionInputs.viewOnly && decisionInputs.executeVisitType == 'FinalReport'">
      <div class="d-flex justify-content-center">
        <mat-button-toggle-group color="primary" appearance="legacy" value="institutionEntries">
          <mat-button-toggle class="first" value="institutionEntries" (click)="currentTab = 0">
            {{(decisionInputs.isMasar ? 'forms.common.Criteria.facilityEntries' :
            'forms.common.Criteria.institutionEntries') | translate}}
          </mat-button-toggle>
          <mat-button-toggle class="second" value="membersEntries" (click)="currentTab = 1">
            {{'forms.common.Criteria.membersEntries' | translate}}
          </mat-button-toggle>
        </mat-button-toggle-group>
      </div>
      <br />
    </ng-container>

    <mat-tab-group class="invisible-tabs" [(selectedIndex)]="currentTab">
      <mat-tab>
        <ng-container [ngSwitch]="criterion.criterionType">
          <app-question-preview *ngSwitchCase="'STICK'"></app-question-preview>
          <app-criteria-preview *ngSwitchDefault></app-criteria-preview>
        </ng-container>
      </mat-tab>

      <mat-tab *ngIf="!decisionInputs.viewOnly && decisionInputs.executeVisitType == 'FinalReport'">
        <lib-members-selector [mode]="'ByCriterion'" [bindReviewer]="true"
          [visitKey]="decisionInputs.visitMetaData.visitKey" [criterionKey]="criterion.criterionKey"
          [(ngModel)]="member"></lib-members-selector>

        <ng-container *ngIf="member" [ngSwitch]="criterion.criterionType">
          <ng-container *ngSwitchCase="'STICK'">
            <app-masar-question-decision [decisionPreview]="true" [memberId]="member.id"
              *ngIf="(decisionInputs$ | async)?.isMasar;else showNormal"></app-masar-question-decision>
            <ng-template #showNormal>
              <app-question-decision [decisionPreview]="true" [memberId]="member.id"></app-question-decision>
            </ng-template>
          </ng-container>

          <app-criteria-decision *ngSwitchDefault [decisionPreview]="true"
            [memberId]="member.id"></app-criteria-decision>
        </ng-container>
      </mat-tab>
    </mat-tab-group>
  </ng-container>
</div>